import styles from './SmoltReportDivider.module.scss';

interface SmoltReportDividerProps {
    marginTop?: number;
    marginBottom?: number;
}

export default function SmoltReportDivider(props: SmoltReportDividerProps) {
    const { marginTop = 16, marginBottom = 16 } = props;
    return <hr className={styles.divider} style={{ marginTop, marginBottom }} />;
}
